import React, { useState } from "react";
import { supabase } from "../supabaseClient";

function IncomingRequestsPanel({ pendingIncomingRequests, user, getName, refreshAll }) {
  const [processingId, setProcessingId] = useState(null);

  const acceptMoney = async (tx) => {
    if (!user?.id) return;
    
    // Prevent double submissions
    setProcessingId(tx.id);

    const fromName = getName(tx.from_user_id);
    const toName = getName(tx.to_user_id);

    // Call the database atomic function wrapper
    const { error } = await supabase.rpc("accept_incoming_money", {
      p_tx_id: tx.id,
      p_approved_by: user.id,
      p_from_user_id: tx.from_user_id,
      p_to_user_id: tx.to_user_id,
      p_amount: Number(tx.amount),
      p_from_note: `Sent to ${toName}`,
      p_to_note: `Received from ${fromName}`
    });

    setProcessingId(null);

    if (error) {
      console.error("Transaction confirmation failed:", error.message);
      alert(`Could not process transfer: ${error.message}`);
      return;
    }

    refreshAll();
  };

  return (
    <>
      <h3 style={{ marginTop: 30 }}>Incoming Requests</h3>
      {!pendingIncomingRequests || pendingIncomingRequests.length === 0 ? (
        <p style={{ color: "#6b7280", fontStyle: "italic", padding: "10px 0" }}>No pending incoming requests.</p>
      ) : (
        pendingIncomingRequests.map((tx) => {
          const isCurrentLoading = processingId === tx.id;
          return (
            <div key={tx.id} style={{ border: "1px solid #e5e7eb", padding: 15, marginBottom: 10, borderRadius: 8, display: "flex", justifyContent: "space-between", alignItems: "center", background: "#fff" }}>
              <span>
                <strong>{getName(tx.from_user_id)}</strong> wants to send you <strong>₹{tx.amount}</strong>
              </span>
              <div style={{ display: "flex", gap: "10px" }}>
                <button 
                  onClick={() => acceptMoney(tx)} 
                  disabled={processingId !== null}
                  style={{ 
                    background: isCurrentLoading ? "#a7f3d0" : "#10b981", 
                    color: "#fff", 
                    padding: "6px 15px", 
                    border: "none", 
                    borderRadius: 5, 
                    cursor: processingId !== null ? "not-allowed" : "pointer", 
                    fontWeight: "bold" 
                  }}
                >
                  {isCurrentLoading ? "Processing..." : "Accept"}
                </button>
              </div>
            </div>
          );
        })
      )}
    </>
  );
}

export default IncomingRequestsPanel;